import { DeviceType, getDeviceTypeAsync } from 'expo-device';
import { lockAsync, OrientationLock } from 'expo-screen-orientation';
import { Platform } from 'react-native';

type DeviceKind = 'phone' | 'tablet' | 'other';
type StartupOrientationLock = 'portrait' | 'none';
interface OrientationDependencies {
  getDeviceType: () => Promise<DeviceType>;
  lock: (orientationLock: OrientationLock) => Promise<void>;
  platform: typeof Platform.OS;
}

export function getStartupOrientationLock({
  deviceType,
  platform,
}: {
  deviceType: DeviceKind;
  platform: typeof Platform.OS;
}): StartupOrientationLock {
  return platform === 'android' && deviceType === 'phone' ? 'portrait' : 'none';
}

function getDeviceKind(deviceType: DeviceType): DeviceKind {
  if (deviceType === DeviceType.TABLET) return 'tablet';
  // Treat UNKNOWN as phone on Android: some emulators / older devices report UNKNOWN,
  // and we'd rather lock a tablet-misidentified-as-phone than leave a real phone unlocked.
  if (deviceType === DeviceType.PHONE || deviceType === DeviceType.UNKNOWN) return 'phone';
  return 'other';
}

export async function lockStartupOrientation(
  dependencies: OrientationDependencies = {
    getDeviceType: getDeviceTypeAsync,
    lock: lockAsync,
    platform: Platform.OS,
  },
) {
  if (dependencies.platform !== 'android') return;

  const deviceType = await dependencies.getDeviceType();
  const lock = getStartupOrientationLock({ deviceType: getDeviceKind(deviceType), platform: dependencies.platform });

  if (lock === 'portrait') {
    await dependencies.lock(OrientationLock.PORTRAIT_UP);
  }
}
